import gql from 'graphql-tag'

const query = gql`
query {
  whoami {
    companyId
  }
}
`

export default query
